// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/contact-us.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/contact-us-414.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/orange-box.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-us {
  display: flex;
  background: #f2f2f7 url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left;
  background-position: right;
  background-size: contain;
  height: 434px;
}
@media screen and (max-width: 830px) {
  .contact-us {
    height: 400px;
  }
}
@media screen and (max-width: 768px) {
  .contact-us {
    height: 256px;
  }
}
@media screen and (max-width: 500px) {
  .contact-us {
    height: 272px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
}
.contact-us_text {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat right;
  background-size: cover;
  width: 70%;
  padding: 7% 5%;
}
@media screen and (max-width: 1440px) {
  .contact-us_text {
    width: 56%;
  }
}
@media screen and (max-width: 768px) {
  .contact-us_text {
    padding: 5%;
  }
}
@media screen and (max-width: 620px) {
  .contact-us_text {
    width: 71%;
    padding: 7% 11% 7% 5%;
  }
}
.contact-us_text-title {
  font-size: 48px;
  font-weight: 700;
  line-height: 62px;
}
@media screen and (max-width: 768px) {
  .contact-us_text-title {
    font-size: 28px;
    line-height: 36px;
  }
}
@media screen and (max-width: 620px) {
  .contact-us_text-title {
    font-size: 24px;
    line-height: 32px;
  }
}
.contact-us_text-desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 27px;
  margin: 20px 0px 20px;
  color: #191919;
}
@media screen and (max-width: 768px) {
  .contact-us_text-desc {
    font-size: 12px;
    line-height: 19.2px;
    margin: 15px 0px 20px;
  }
}
@media screen and (max-width: 500px) {
  .contact-us_text-desc {
    font-size: 10px;
    line-height: 12px;
    margin: 15px 0px 0px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/ContactUs.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,0EAAA;EACA,0BAAA;EACA,wBAAA;EACA,aAAA;AACJ;AAAI;EANJ;IAOQ,aAAA;EAGN;AACF;AAFI;EATJ;IAUQ,aAAA;EAKN;AACF;AAJI;EAZJ;IAaQ,aAAA;IACA,yDAAA;EAON;AACF;AALI;EACI,mEAAA;EACA,sBAAA;EACA,UAAA;EACA,cAAA;AAOR;AANQ;EALJ;IAMQ,UAAA;EASV;AACF;AARQ;EARJ;IASQ,WAAA;EAWV;AACF;AAVQ;EAXJ;IAYQ,UAAA;IACA,qBAAA;EAaV;AACF;AAXQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAaZ;AAXY;EALJ;IAMQ,eAAA;IACA,iBAAA;EAcd;AACF;AAbY;EATJ;IAUQ,eAAA;IACA,iBAAA;EAgBd;AACF;AAbQ;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AAeZ;AAdY;EANJ;IAOQ,eAAA;IACA,mBAAA;IACA,qBAAA;EAiBd;AACF;AAhBY;EAXJ;IAYQ,eAAA;IACA,iBAAA;IACA,oBAAA;EAmBd;AACF","sourcesContent":[".contact-us {\n    display: flex;\n    background: #f2f2f7ff url(\"../../assets/images/contact-us.png\") no-repeat left;\n    background-position: right;\n    background-size: contain;\n    height: 434px;\n    @media screen and (max-width: 830px) {\n        height: 400px;\n    }\n    @media screen and (max-width: 768px) {\n        height: 256px;\n    }\n    @media screen and (max-width: 500px) {\n        height: 272px;\n        background-image: url(\"../../assets/images/contact-us-414.png\");\n    }\n\n    &_text{\n        background: url(\"../../assets/images/orange-box.png\") no-repeat right;\n        background-size: cover;\n        width: 70%;\n        padding: 7% 5%;\n        @media screen and (max-width: 1440px) {\n            width: 56%;\n        }\n        @media screen and (max-width: 768px) {\n            padding: 5%;\n        }\n        @media screen and (max-width: 620px) {\n            width: 71%;\n            padding: 7% 11% 7% 5%;\n        }\n\n        &-title {\n            font-size: 48px;\n            font-weight: 700;\n            line-height: 62px;\n\n            @media screen and (max-width: 768px) {\n                font-size: 28px;\n                line-height: 36px;\n            }\n            @media screen and (max-width: 620px) {\n                font-size: 24px;\n                line-height: 32px;\n            }\n        }\n\n        &-desc {\n            font-size: 18px;\n            font-weight: 400;\n            line-height: 27px;\n            margin: 20px 0px 20px;\n            color: #191919;\n            @media screen and (max-width: 768px) {\n                font-size: 12px;\n                line-height: 19.2px;\n                margin: 15px 0px 20px;\n            }\n            @media screen and (max-width: 500px) {\n                font-size: 10px;\n                line-height: 12px;\n                margin: 15px 0px 0px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
